module.exports = "<div class=\"col-sm-10\">\n  <div *ngFor=\"let dataObject of value; let i = index\" class=\"row custom-object\">\n    <div class=\"row\">\n      <div *ngFor=\"let customObject of [adminService.schema[key].schema.paths]\">\n        <div class=\"col-sm-12\">\n          <app-schema-show\n          [schema]=\"customObject\"\n          [object]=\"value[i]\">\n          </app-schema-show>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/admin/shared/display-array-embedded/display-array-embedded.component.html
// module id = 289
// module chunks = 0 1